import styled from 'styled-components/native'

export const Tile = styled.View`
  margin: 5px;
  width: 160px;
`
